<template>
  <div class="period-buttons">
    <button
      v-for="p in periods"
      :key="p.value"
      :class="{ active: p.value === selected }"
      @click="$emit('change', p.value)"
    >
      {{ p.label }}
    </button>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    selected: String,
  },
  data() {
    return {
      periods: [
        { value: "1W", label: "1주" },
        { value: "1M", label: "1달" },
        { value: "1Y", label: "1년" },
        { value: "5Y", label: "5년" },
        { value: "10Y", label: "10년" },
      ],
    };
  },
};
</script>
